import React, { useEffect } from 'react';
import $ from 'jquery';

export const ModalError = ({ children, onClose = () => {} }) => {
    useEffect(() => {
        $(`#modal_error`).modal('show');
    });

    return (
        <div className="modal" id={`modal_error`} tabIndex="-1" role="dialog">
            <div className="modal-body alert alert-danger">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
                {children}
            </div>
        </div>
    );
};
